import { ArrowRight } from "lucide-react";

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-28 md:py-36 px-6 md:px-12 lg:px-24 bg-ivoire"
        >
            <div className="max-w-[1600px] mx-auto">
                {/* En-tête minimaliste */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-end mb-14 md:mb-20">
                    <p className="eyebrow md:col-span-3">À propos</p>
                    <h2 className="md:col-span-9 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
                        Moi, c'est{" "}
                        <span className="italic font-normal text-fuchsia">Mélanie</span>.
                    </h2>
                </div>

                {/* Photo signature — portrait centré */}
                <figure className="relative mx-auto max-w-3xl">
                    <div className="relative aspect-[3/4] overflow-hidden">
                        <img
                            src="/melanie-about.png"
                            alt="Mélanie Perez, créatrice de contenu et UGC à Bordeaux — portrait de marque"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    {/* Fins cadres or décoratifs */}
                    <span className="hidden md:block absolute -top-5 -left-5 w-24 h-24 border border-gold pointer-events-none" />
                    <span className="hidden md:block absolute -bottom-5 -right-5 w-24 h-24 border border-gold pointer-events-none" />
                    <figcaption className="mt-6 flex flex-wrap items-center justify-between gap-4 text-[10px] uppercase tracking-[0.32em] text-[#888]">
                        <span>Portrait — Bordeaux, 2026</span>
                        <span className="text-gold">
                            UGC &middot; Lifestyle &middot; Bonnes adresses
                        </span>
                    </figcaption>
                </figure>

                {/* Texte — lecture centrée, éditoriale */}
                <div className="mt-20 md:mt-28 max-w-3xl mx-auto">
                    <div className="space-y-6 text-[#3A3A3A] text-base md:text-lg leading-[1.8]">
                        <p>
                            Créatrice de contenu &amp; UGC basée à Bordeaux, je partage depuis
                            plusieurs années mes découvertes, mes bonnes adresses et mes coups
                            de cœur sur les réseaux sociaux.
                        </p>
                        <p>
                            Restaurants, sorties, expériences, beauté, lifestyle… je n'ai
                            jamais eu envie de choisir une seule case.
                        </p>
                    </div>

                    {/* Pull-quote 1 */}
                    <div className="my-14 md:my-20 text-center">
                        <p className="font-display italic text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-ink">
                            Ce que j'aime,<br />
                            c'est <span className="text-fuchsia">découvrir</span>.
                        </p>
                    </div>

                    <div className="space-y-6 text-[#3A3A3A] text-base md:text-lg leading-[1.8]">
                        <p>
                            Tester une nouvelle adresse, essayer un produit, vivre une
                            expérience, trouver le bon angle, sortir mon téléphone et
                            transformer tout ça en contenu.
                        </p>
                        <p>
                            Aujourd'hui, je mets aussi cette créativité au service des
                            marques, restaurants et établissements en créant des contenus UGC
                            pensés pour les réseaux sociaux.
                        </p>
                    </div>

                    {/* Pull-quote 2 — Mon approche */}
                    <div className="my-14 md:my-20 border-t border-b border-ink/15 py-10 md:py-12">
                        <p className="text-[10px] uppercase tracking-[0.32em] text-gold mb-5">
                            Mon approche
                        </p>
                        <p className="font-display italic text-2xl md:text-3xl lg:text-[2.25rem] leading-[1.2] text-ink">
                            Du naturel, un œil esthétique, du rythme —{" "}
                            <span className="text-fuchsia">et surtout</span> ma façon de
                            raconter les choses.
                        </p>
                    </div>

                    <div className="space-y-6 text-[#3A3A3A] text-base md:text-lg leading-[1.8]">
                        <p>
                            Je peux créer du contenu destiné aux réseaux de votre marque, mais
                            aussi imaginer des collaborations diffusées auprès de ma propre
                            communauté.
                        </p>
                        <p className="text-ink">
                            Basée à Bordeaux, disponible pour des projets partout en France.
                        </p>
                    </div>

                    <div className="mt-14 flex justify-center">
                        <a
                            href="#portfolio"
                            data-testid="about-cta"
                            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.24em] text-ink border-b border-ink/40 pb-2 hover:text-fuchsia hover:border-fuchsia transition-colors"
                        >
                            Découvrir mes créations
                            <ArrowRight className="w-4 h-4" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
